<template>
    <div id="default-layout">
      <router-view />
    </div>
  </template>
  
  <script setup>
  
  </script>
  
  <style scoped lang="scss">
 
  </style>
  